import { render } from "./hemaBill.vue?vue&type=template&id=52cc3ce8&scoped=true"
import script from "./hemaBill.vue?vue&type=script&lang=js"
export * from "./hemaBill.vue?vue&type=script&lang=js"

import "./hemaBill.vue?vue&type=style&index=0&id=52cc3ce8&scoped=true&lang=css"
import "./hemaBill.vue?vue&type=style&index=1&id=52cc3ce8&lang=css"
script.render = render
script.__scopeId = "data-v-52cc3ce8"

export default script